export default __webpack_public_path__ + "static/media/ProductListLightT.535ef2fe.svg";